module.exports = __webpack_public_path__ + "files/42c6f942e6bdd428b9f5af5cfc04d396.png";